import { render, staticRenderFns } from "./process.vue?vue&type=template&id=07c71b61&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"
import style0 from "./process.vue?vue&type=style&index=0&id=07c71b61&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c71b61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c71b61')) {
      api.createRecord('07c71b61', component.options)
    } else {
      api.reload('07c71b61', component.options)
    }
    module.hot.accept("./process.vue?vue&type=template&id=07c71b61&scoped=true", function () {
      api.rerender('07c71b61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/examine/process.vue"
export default component.exports